import { render } from "./MessageNotification.vue?vue&type=template&id=8be188dc"
import script from "./MessageNotification.vue?vue&type=script&lang=js"
export * from "./MessageNotification.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MessageNotification.vue"]])

export default __exports__